import { Connection, FileType, LogisticNetwork } from '@/types/data';
import { useNetworks } from '@/hooks/useNetworks';
import { useFileData } from '@/hooks/useFileData';

export const useConnectionsData = (currentNetwork: LogisticNetwork | null) => {
  const { getEditedConnections, autosaveConnections } = useNetworks();

  // Create empty row configuration
  const createEmptyRow = (): Connection => ({
    courier: '',
    start: '',
    end: '',
    zone: '',
    priority: '',
    book_on_scan: 'n',
    book_on_booking: 'n',
    book_on_tracking_from_previous_leg: 'n',
  });

  // Use the generic file data hook
  const {
    data: connections,
    isEdited,
    isSaving,
    addEmptyRow,
    discardChanges,
    handleRowsChange,
    deleteRow,
  } = useFileData<Connection>(currentNetwork, {
    fileType: FileType.Connections,
    getEditedData: getEditedConnections,
    autosaveData: autosaveConnections,
    createEmptyRow,
  });

  return {
    connections,
    isEdited,
    isSaving,
    addEmptyRow,
    discardChanges,
    handleRowsChange,
    deleteRow,
  };
};
